import React, {PropsWithChildren} from "react";
import {Tabs, Tab, TabContentProps} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";

function UrlTabs({
  queryParameter, defaultActiveKey, baseUrl, onSelect, children
}: PropsWithChildren<{
  queryParameter: string;
  baseUrl: string | ((key: string) => string);
  onSelect?: (key: string) => void;
  defaultActiveKey?: string;
}>) {
  const params = useParams();
  const navigate = useNavigate();
  const activeKey = params[queryParameter] || defaultActiveKey;
  return (
    <Tabs
      onSelect={(key) => {
        if (key) {
          const url = typeof baseUrl === 'string'
            ? `${baseUrl.replace(/\/$/, '')}/${key}`
            : baseUrl(key);

          navigate(url);
          if (onSelect) onSelect(key);
        }
      }}
      activeKey={activeKey}
    >
      {children}
    </Tabs>
  )
}

UrlTabs.Tab = Tab;
UrlTabs.TabContent = function ContentWrapper ({ children }: TabContentProps) {
  return <Tab.Content className="py-3">{children}</Tab.Content>
}

export default UrlTabs;
